import { useEffect, useState } from "react";
//import apiClient from "../services/api";
import { getFaqs } from "../services/faqsService";
import "../styles/Faqs.css";

export default function Faqs() {
    const [faqs, setFaqs] = useState([]);
    const [openId, setOpenId] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchFaqs = async () => {
            try {
                const response = await getFaqs();

                setFaqs(response.data || []);
            } catch (error) {
                console.error("Failed to load FAQs:", error);
                setError("Unable to load FAQs.");
            } finally {
                setLoading(false);
            }
        };

        fetchFaqs();
    }, []);

    const handleToggle = (id) => {
        setOpenId((currentId) =>
            currentId === id ? null : id
        );
    };

    if (loading) {
        return (
            <div className="faqs-page">
                <div className="faqs-loading">
                    Loading...
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="faqs-page">
                <div className="faqs-error">
                    {error}
                </div>
            </div>
        );
    }



    return (
        <main className="faqs-page" dir="rtl">

            <div className="faqs-container">

                <div className="faqs-header">
                    <h1>سوالات متداول</h1>

                    <p>
                        پاسخ سوالات متداول خود را در این بخش پیدا کنید.
                    </p>
                </div>

                <div className="faqs-list">

                    {faqs.map((faq) => {

                        const isOpen = openId === faq.id;

                        return (
                            <div
                                key={faq.id}
                                className={`faq-item ${isOpen ? "faq-item--open" : ""
                                    }`}
                            >

                                <button
                                    type="button"
                                    className="faq-question"
                                    onClick={() => handleToggle(faq.id)}
                                    aria-expanded={isOpen}
                                >

                                    <span className="faq-question__text">
                                        {faq.question}
                                    </span>

                                    <span className="faq-question__icon">
                                        {isOpen ? "−" : "+"}
                                    </span>

                                </button>

                                {isOpen && (
                                    <div className="faq-answer">
                                        <p>
                                            {faq.answer}
                                        </p>
                                    </div>
                                )}

                            </div>
                        );
                    })}

                </div>

            </div>

        </main>
    );
}